import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { modelOf } from '../../../../prop-types';
import AnalyticsService from '../../../../services/AnalyticsService';
import CheckoutStore from '../../../../store/CheckoutStore';
import CheckoutPageModule from '../../../../types/checkout/CheckoutPageModule';
import CheckoutModule from '../../common/CheckoutModule';
import CheckoutPaymentMethod from '../CheckoutPaymentMethod';

const CheckoutPaymentMethodModule = ({
  analyticsService,
  checkoutStore,
  onOrderUpdate,
  orderNumber,
}) => {
  const { order } = checkoutStore;
  const { paymentMethodAlerts } = order;

  const handleUpdate = (args) => {
    onOrderUpdate({
      module: CheckoutPageModule.PAYMENT_METHOD_MODULE,
      ...args,
    });
    analyticsService.addPaymentInfo({
      products: order.productList,
      productsTotal: order.productsTotal.value,
    });
  };

  return (
    <CheckoutModule
      className="CheckoutPaymentMethodModule"
      generalAlerts={paymentMethodAlerts.general}
      errorAlerts={paymentMethodAlerts.errors}
      title={
        <FormattedMessage
          id="checkout.paymentMethod.title"
          defaultMessage="Select payment method"
        />
      }
      orderNumber={orderNumber}
      module={CheckoutPageModule.PAYMENT_METHOD_MODULE}
    >
      <CheckoutPaymentMethod onOrderUpdate={handleUpdate} />
    </CheckoutModule>
  );
};

CheckoutPaymentMethodModule.propTypes = {
  analyticsService: PropTypes.instanceOf(AnalyticsService).isRequired,
  checkoutStore: modelOf(CheckoutStore).isRequired,
  onOrderUpdate: PropTypes.func.isRequired,
  orderNumber: PropTypes.number.isRequired,
};

export default inject(
  'analyticsService',
  'checkoutStore'
)(observer(CheckoutPaymentMethodModule));
